import { isUndefined } from 'lodash-es';
import { Children, type ReactNode } from 'react';

import { applyThresholdDefaults } from './apply-threshold-defaults.js';
import { isSlot } from '../../../../core/utils/is-slot.js';
import { Icon } from '../slots/Icon.js';
import { Label } from '../slots/Label.js';
import { Max } from '../slots/Max.js';
import { Min } from '../slots/Min.js';
import { Threshold } from '../slots/Threshold.js';
import { ThresholdLegend } from '../slots/ThresholdLegend.js';
import { Tooltip } from '../slots/Tooltip.js';
import { Value } from '../slots/Value.js';
import { MeterBarChartSlots } from '../types/meter-bar-chart-config.js';

export function iterateSlots(children?: ReactNode) {
  const slots: MeterBarChartSlots = {};

  Children.forEach(children, (child) => {
    if (isSlot(child, Label)) {
      slots.label = child.props.children;
    } else if (isSlot(child, Icon)) {
      slots.icon = child.props.children;
    } else if (isSlot(child, Value)) {
      slots.value = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Min)) {
      slots.min = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Max)) {
      slots.max = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Threshold)) {
      const threshold = applyThresholdDefaults(child.props);
      if (slots.thresholds?.data) {
        slots.thresholds.data.push(threshold);
      } else {
        slots.thresholds = { data: [threshold] };
      }
    } else if (isSlot(child, ThresholdLegend)) {
      slots.thresholds
        ? (slots.thresholds.legend = true)
        : (slots.thresholds = { data: [], legend: true });
    } else if (isSlot(child, Tooltip)) {
      slots.tooltip = true;
    }
  });

  return slots;
}
